import { SuretyBondIssuanceMethod } from "@inrev/common";
import { FormComponent, FormFieldGroup, FormRow, FormSection } from "@portal/components/form";
import {
	FormDateComponent,
	FormDropdownComponent,
	FormInputComponent,
	FormStateDropdownComponent,
} from "@portal/components/form/fieldLayouts";
import { FormFileUpload } from "@portal/components/form/fields";
import { useObligeeRoleOptions } from "@portal/hooks/useObligeeRoleOptions";
import { useFormContext } from "react-hook-form";
import { BOND_FORM_TYPE_OPTIONS } from "../constants";
import type { AdminImportBondViewFormData } from "../types";

const ISSUANCE_METHOD_OPTIONS = SuretyBondIssuanceMethod.options();

type BondFormSectionProps = {
	isBid: boolean;
};

export const BondFormSection = ({ isBid }: BondFormSectionProps) => {
	const formMethods = useFormContext<AdminImportBondViewFormData>();
	const obligeeRoleOptions = useObligeeRoleOptions();

	return (
		<FormSection header="Bond Form">
			<FormFieldGroup condensed>
				<FormRow>
					<FormDropdownComponent
						formMethods={formMethods}
						name="bondForm.issuanceMethod"
						label="Issuance Method"
						inline
						options={ISSUANCE_METHOD_OPTIONS}
						placeholder="Select one"
					/>
					{!isBid && (
						<FormDropdownComponent
							formMethods={formMethods}
							name="bondForm.data.bondFormType"
							label="Bond Form Type"
							inline
							options={BOND_FORM_TYPE_OPTIONS}
							placeholder="Select one"
						/>
					)}
					<FormDateComponent
						formMethods={formMethods}
						name="bondForm.effectiveDate"
						label="Effective Date"
						inline
					/>
				</FormRow>
				<FormInputComponent
					formMethods={formMethods}
					name="bondForm.data.contractDescription"
					label="Description"
					inline
				/>
				<FormRow>
					<FormInputComponent
						formMethods={formMethods}
						name="bond.obligees.0.name"
						label="Obligee Name"
						inline
					/>
					<FormDropdownComponent
						formMethods={formMethods}
						name="bond.obligees.0.role"
						label="Obligee Role"
						inline
						options={obligeeRoleOptions}
						placeholder="Select one"
						optionsClassName="max-h-[35vh]"
					/>
				</FormRow>
				<FormInputComponent
					formMethods={formMethods}
					name="bond.obligees.0.address.street"
					label="Obligee Street"
					inline
				/>
				<FormRow>
					<FormInputComponent
						formMethods={formMethods}
						name="bond.obligees.0.address.city"
						label="Obligee City"
						inline
					/>
					<FormStateDropdownComponent
						formMethods={formMethods}
						name="bond.obligees.0.address.state"
						label="Obligee State"
						inline
					/>
					<FormInputComponent
						formMethods={formMethods}
						name="bond.obligees.0.address.zip"
						label="Obligee Zip"
						inline
						onlyNumbers
						maxLength={5}
					/>
				</FormRow>
				<FormComponent
					formMethods={formMethods}
					name="issuedBondFormFile"
					label="Issued Bond Form"
					inline
				>
					<FormFileUpload
						control={formMethods.control}
						name="issuedBondFormFile"
						placeholderText="Drag and drop or click to upload the filled bond form (PDF)"
					/>
				</FormComponent>
			</FormFieldGroup>
		</FormSection>
	);
};
